export function loadTypekit() {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://use.typekit.net/fvk6moy.css';
  document.head.appendChild(link);
}

loadTypekit();